import { env } from "@/constants/env";
import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { Routes, createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router";

export const initializeSentry = () => {
  Sentry.init({
    dsn: env.SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      // See docs for support of different versions of variation of react router
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      //   Sentry.replayIntegration(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
    tracesSampleRate: 1.0,

    // ref: https://docs.sentry.io/platforms/javascript/guides/react/tracing/trace-propagation/
    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: [
      /^http:\/\/localhost:8888/, // local dev server
      /^https:\/\/api2\.backpac\.app/, // production server
    ],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
};

export const SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes);
